import React from 'react';
import NotificationItem from "./NotificationItem";
import PropTypes from "prop-types";

const AppNotification = ({notifications, onNotificationClick}) => {
    $('.messages-list').slimscroll({
        height: '280px'
    });
    return (
        <div className="messages-list">
            <ul className="list-unstyled">
                {notifications && notifications.map && notifications.map((notification, index) =>
                    <NotificationItem key={index} notification={notification}
                                      onNotificationClick={(deviceID, timestamp) => {
                                          onNotificationClick(deviceID, timestamp);
                                      }}/>)
                }
            </ul>
        </div>
    )
};

AppNotification.propTypes = {
    notifications: PropTypes.array.isRequired,
    onNotificationClick: PropTypes.func.isRequired
};

export default AppNotification;




// WEBPACK FOOTER //
// ./components/AppNotification/index.js